import React from 'react';
import dayjs from 'dayjs';
import CalendarWidget from 'components/FormFields/CalendarWidget';
import TimeZoneSelect from '../Calendar.TimeZoneSelect';

const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';

const EventDate = ({
  start,
  end,
  allDay,
  datePreference,
  myTimeZone,
  projectTimeZone,
  displayTz,
  setStart,
  setEnd,
  setTimeZone,
  adjustEndTime = true, // This is for handling FC events where the end time for all day events is exclusive
}) => {
  const dateFormat = datePreference?.toUpperCase() ?? DEFAULT_DATE_FORMAT;

  let adjustedEnd = end;
  if (allDay && adjustEndTime) {
    adjustedEnd = end ? dayjs(end).subtract(1, 'day') : start;
  }

  return (
    <div className="event-card__date-picker">
      <CalendarWidget
        name="From"
        date={dayjs(start).format(dateFormat)}
        pickerDate={dayjs(start).format(dateFormat)}
        datePreference={dateFormat}
        hasClear={false}
        required
        setDate={setStart}
        dateFormatLabel="YYYY-MM-DD"
        nNextYears={10}
        showNextYears
      />

      {adjustedEnd ? (
        <CalendarWidget
          name="To"
          date={dayjs(adjustedEnd).format(dateFormat)}
          pickerDate={dayjs(adjustedEnd).format(dateFormat)}
          datePreference={dateFormat}
          hasClear={false}
          required
          setDate={setEnd}
          dateFormatLabel="YYYY-MM-DD"
          nNextYears={10}
          showNextYears
        />
      ) : null}
      {displayTz && (
        <TimeZoneSelect
          myTimeZone={myTimeZone}
          projectTimeZone={projectTimeZone}
          timeZone={displayTz}
          onTimeZoneChange={setTimeZone}
          displayMyTimezone
          displayProjectTimezone
          required
        />
      )}
    </div>
  );
};

export default EventDate;
